// core version + navigation, pagination modules:
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import { animateHeroSlide } from './effects/hero-effects.js';


document.addEventListener('DOMContentLoaded', () => {
  
  // Small delay to ensure DOM is fully painted
  setTimeout(() => {
    // Check if hero element exists
    const heroElement = document.querySelector('.rdv-hero__swiper');
    if (!heroElement) {
      console.error('Hero element not found - selector: .rdv-hero__swiper');
      console.log('Available hero classes:', document.querySelector('[class*="rdv-hero"]')?.className);
      return;
    }
    
    try {
      // inicialización Swiper y GSAP aquí
      const swiper = new Swiper('.rdv-hero__swiper', {
        // configure Swiper to use modules
        modules: [Navigation, Pagination],
        // Optional parameters
        direction: 'horizontal',
        loop: true,

        // If we need pagination
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },

        // Navigation arrows
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        on: {
          init: function() {
            const heroEl = document.querySelector('.rdv-hero__swiper');
            if (heroEl) {
              heroEl.classList.add('is-ready');
            }
          },
          slideChangeTransitionStart() {
            const activeSlide = this.slides[this.activeIndex];
            animateHeroSlide(activeSlide);
          }
        }
      });

    } catch (error) {
      console.error('Error initializing Swiper:', error);
    }
  }, 100);
});